import { combineReducers } from 'redux';
import claimReducer from './store/reducers/claimReducer';
import agencyReducer from "./store/reducers/agencyReducer";
import taskReducer from "./store/reducers/taskReducer";
import authReducer from "./store/reducers/authReducer";
import repairerReducer from "./store/reducers/repairerReducer";
import inspectorReducer from "./store/reducers/inspectorReducer";
import userReducer from "./store/reducers/userReducer";
import paymentReducer from "./store/reducers/paymentReducer";
import imageReducer from "./store/reducers/imageReducer";
import inspectorShiftTimeslotReducer from "./store/reducers/inspectorShiftTimeslotReducer";
import replacementCarRequestsReducer from "./store/reducers/replacementCarRequestsReducer";
import inspectionReducer from "./store/reducers/expertisesReducer";
import modeGestionReducer from "./store/reducers/modeGestionReducer";
import communicationChannelReducer from './store/reducers/communicationChannelReducer';
import investigationReducer from './store/reducers/investigationReducer';
import investigationActionReducer from './store/reducers/investigationActionReducer';
import causeReducer from "./store/reducers/causeReducer";
import formReducer from "./store/reducers/formReducer";
import inspectorShiftReducer from "./store/reducers/inspectorShift";

const rootReducer = combineReducers({
    claimReducer,
    agencyReducer,
    taskReducer,
    inspectorReducer,
    auth: authReducer,
    repairers: repairerReducer,
    filteredRepairers: repairerReducer,
    filteredInspectors: inspectorReducer,
    fetchedInspector: inspectorReducer,
    user: userReducer,
    paymentReducer,
    imageReducer,
    inspectorShiftTimeslotReducer,
    replacementCarRequestsReducer,
    inspectionReducer,
    modeGestionReducer,
    communicationChannelReducer,
    investigationReducer,
    investigationActionReducer,
    formReducer,
    causeReducer,
    inspectorShift: inspectorShiftReducer,
});

export default rootReducer;